import React, { useEffect, useRef } from 'react';
import { Trans } from 'react-i18next';
import Accordion from 'react-bootstrap/Accordion';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Placeholder from 'react-bootstrap/Placeholder';
import Container from 'react-bootstrap/Container';
import { useDispatch, useSelector } from 'react-redux';
import { getAssetClasses } from '../../redux/slices';
import AssetClass from '../AssetClass';
import HeatMapHeader from '../../components/HeatMapHeader';
import i18next from '../../translations/i18n';
import './index.scss';

const getLastUpdatedDt = (data) => {
  try {
    const dates = data.map((e) => e.groups.map(g => g.underlyingList.map(u => u.lastUpdated))).flat(2);
    return dates.filter(f => f !== undefined).sort().reverse()[0];
  } catch (e) {
    return null;
  }
};

const ContentPlaceHolder = React.memo(() => (
  [...Array(3).keys()].map((item, i) => (
    <Col key={item} xs={12} md={4} className={i < 2 ? 'border-end' : ''}>
      <Placeholder as="p" xs={12} className="h4 text-center my-4" />
      <Container className="px-2 px-md-2 px-md-4">
        <Row className="g-3 g-md-4 g-lg-5">
          {[...Array(12).keys()].map((holder) => (
            <Col xs={6} key={`key_${holder}`}>
              <Placeholder as={Col} animation="glow">
                <Placeholder xs={12} />
                <Placeholder xs={12} />
                <Placeholder xs={12} />
              </Placeholder>
            </Col>
          ))}
        </Row>
      </Container>
    </Col>
  ))
));

const Content = () => {
  let interval;
  const dispatch = useDispatch();
  const assetClasses = useSelector(state => state.app).data;
  const groupWrapper = useRef(null);

  const loadContent = async () => {
    dispatch(getAssetClasses());
  }; // end loadContent

  useEffect(() => {
    const init = async () => {
      await loadContent();
      if (!interval) {
        interval = setInterval(loadContent, 1000 * 10);
      }
    };
    init();
    return () => {
      clearInterval(interval);
    };
  }, []);

  const isLoading = assetClasses.length === 0;
  return (
    <>
      <header>
        <Row className="px-3 justify-content-md-center">
          <Col xs={12} md={8}>
            <>
              <p className="text-center py-4 h2">
                {isLoading && <Placeholder animation="glow"> <Placeholder xs={6} /> </Placeholder>}
                {!isLoading && <> {i18next.t('HeatMapAppHeading')}</>}
              </p>
              <p className="text-center fw-normal h5">
                {isLoading && <Placeholder animation="glow"> <Placeholder xs={6} /> </Placeholder>}
                {!isLoading && <>{i18next.t('HeatMapInfo')} </>}
              </p>
            </>
          </Col>
        </Row>

      </header>
      <main ref={groupWrapper} className="content">
        <section className="content__header mb-3 p-3">
          <HeatMapHeader lastUpdated={getLastUpdatedDt(assetClasses)} />
        </section>
        {/* For Mobiles */}
        <section className="content-accordion d-md-none">
          <Accordion
            defaultActiveKey={['0', '1', '2']}
            alwaysOpen
            flush
            className="border-top border-bottom"
          >
            {assetClasses.length === 0 && <ContentPlaceHolder />}
            {assetClasses.map((assetClass, index) => (
              <Accordion.Item eventKey={`${index}`} key={assetClass.name}>
                <Accordion.Header className="my-2">
                  <p className="h4 text-center mt-2"><Trans>{assetClass.name}</Trans></p>
                </Accordion.Header>
                <Accordion.Body className="px-0">
                  <AssetClass assetClassName={assetClass.name ? assetClass.name.toLowerCase() : ''} data={assetClass} />
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </section>
        {/* For Desktops */}
        <section className="content__asset-class d-none d-md-block mb-5">
          <Row className="d-flex justify-content-center m-0">
            {assetClasses.length === 0 && <ContentPlaceHolder />}
            {assetClasses.map((assetClass) => (
              <Col key={assetClass.name} className={assetClass.name ? assetClass.name.toLowerCase() : ''}>
                <p className="h4 text-center my-4"><Trans>{assetClass.name}</Trans></p>
                <AssetClass assetClassName={assetClass.name ? assetClass.name.toLowerCase() : ''} data={assetClass} />
              </Col>
            ))}
          </Row>
        </section>
      </main>
    </>
  );
};

export default Content;
